
import TaskList from '../components/task-list.vue';

export default {
  name: 'SubmittedDemandTaskList',

  components: {
    TaskList: TaskList
  }
};